var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetItOnPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 216 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 64H8C3.6 64 0 60.4 0 56V8C0 3.6 3.6 0 8 0H208C212.4 0 216 3.6 216 8V56C216 60.4 212.4 64 208 64Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8697 16.3891C75.8697 17.7299 75.4729 18.7971 74.6777 19.5939C73.7737 20.5411 72.5977 21.0147 71.1513 21.0147C69.7657 21.0147 68.5865 20.5347 67.6185 19.5731C66.6473 18.6131 66.1641 17.4211 66.1641 16.0003C66.1641 14.5779 66.6473 13.3875 67.6185 12.4259C68.5865 11.4659 69.7657 10.9859 71.1513 10.9859C71.8377 10.9859 72.4969 11.1203 73.1209 11.3875C73.7465 11.6563 74.2473 12.0131 74.6233 12.4595L73.7785 13.3043C73.1433 12.5459 72.2681 12.1651 71.1513 12.1651C70.1401 12.1651 69.2665 12.5203 68.5289 13.2307C67.7913 13.9427 67.4233 14.8643 67.4233 16.0003C67.4233 17.1347 67.7913 18.0579 68.5289 18.7683C69.2665 19.4803 70.1401 19.8339 71.1513 19.8339C72.2233 19.8339 73.1161 19.4771 73.8329 18.7619C74.2969 18.2963 74.5657 17.6499 74.6361 16.8179H71.1513V15.6643H75.8025C75.8473 15.9155 75.8697 16.1555 75.8697 16.3891Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8697 16.3891C75.8697 17.7299 75.4729 18.7971 74.6777 19.5939C73.7737 20.5411 72.5977 21.0147 71.1513 21.0147C69.7657 21.0147 68.5865 20.5347 67.6185 19.5731C66.6473 18.6131 66.1641 17.4211 66.1641 16.0003C66.1641 14.5779 66.6473 13.3875 67.6185 12.4259C68.5865 11.4659 69.7657 10.9859 71.1513 10.9859C71.8377 10.9859 72.4969 11.1203 73.1209 11.3875C73.7465 11.6563 74.2473 12.0131 74.6233 12.4595L73.7785 13.3043C73.1433 12.5459 72.2681 12.1651 71.1513 12.1651C70.1401 12.1651 69.2665 12.5203 68.5289 13.2307C67.7913 13.9427 67.4233 14.8643 67.4233 16.0003C67.4233 17.1347 67.7913 18.0579 68.5289 18.7683C69.2665 19.4803 70.1401 19.8339 71.1513 19.8339C72.2233 19.8339 73.1161 19.4771 73.8329 18.7619C74.2969 18.2963 74.5657 17.6499 74.6361 16.8179H71.1513V15.6643H75.8025C75.8473 15.9155 75.8697 16.1555 75.8697 16.3891Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2447 12.3792H78.8735V15.4224H82.8143V16.576H78.8735V19.6192H83.2447V20.8H77.6399V11.2H83.2447V12.3792Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2447 12.3792H78.8735V15.4224H82.8143V16.576H78.8735V19.6192H83.2447V20.8H77.6399V11.2H83.2447V12.3792Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4464 20.8H87.2128V12.3792H84.5312V11.2H91.1281V12.3792H88.4464V20.8Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4464 20.8H87.2128V12.3792H84.5312V11.2H91.1281V12.3792H88.4464V20.8Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9009 20.8H97.1345V11.2H95.9009V20.8Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9009 20.8H97.1345V11.2H95.9009V20.8Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.605 20.8H101.371V12.3792H98.6897V11.2H105.286V12.3792H102.605V20.8Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.605 20.8H101.371V12.3792H98.6897V11.2H105.286V12.3792H102.605V20.8Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.647 18.7555C112.357 19.4755 113.226 19.8339 114.255 19.8339C115.282 19.8339 116.152 19.4755 116.863 18.7555C117.573 18.0355 117.93 17.1171 117.93 16.0003C117.93 14.8835 117.573 13.9635 116.863 13.2451C116.152 12.5251 115.282 12.1651 114.255 12.1651C113.226 12.1651 112.357 12.5251 111.647 13.2451C110.938 13.9635 110.581 14.8835 110.581 16.0003C110.581 17.1171 110.938 18.0355 111.647 18.7555ZM117.775 19.5587C116.831 20.5299 115.658 21.0147 114.255 21.0147C112.852 21.0147 111.679 20.5299 110.736 19.5587C109.792 18.5891 109.322 17.4035 109.322 16.0003C109.322 14.5971 109.792 13.4099 110.736 12.4403C111.679 11.4707 112.852 10.9859 114.255 10.9859C115.65 10.9859 116.82 11.4723 117.768 12.4467C118.716 13.4211 119.189 14.6051 119.189 16.0003C119.189 17.4035 118.717 18.5891 117.775 19.5587Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.647 18.7555C112.357 19.4755 113.226 19.8339 114.255 19.8339C115.282 19.8339 116.152 19.4755 116.863 18.7555C117.573 18.0355 117.93 17.1171 117.93 16.0003C117.93 14.8835 117.573 13.9635 116.863 13.2451C116.152 12.5251 115.282 12.1651 114.255 12.1651C113.226 12.1651 112.357 12.5251 111.647 13.2451C110.938 13.9635 110.581 14.8835 110.581 16.0003C110.581 17.1171 110.938 18.0355 111.647 18.7555ZM117.775 19.5587C116.831 20.5299 115.658 21.0147 114.255 21.0147C112.852 21.0147 111.679 20.5299 110.736 19.5587C109.792 18.5891 109.322 17.4035 109.322 16.0003C109.322 14.5971 109.792 13.4099 110.736 12.4403C111.679 11.4707 112.852 10.9859 114.255 10.9859C115.65 10.9859 116.82 11.4723 117.768 12.4467C118.716 13.4211 119.189 14.6051 119.189 16.0003C119.189 17.4035 118.717 18.5891 117.775 19.5587Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.92 20.8V11.2H122.421L127.086 18.6672H127.141L127.086 16.8176V11.2H128.322V20.8H127.034L122.154 12.9696H122.099L122.154 14.8208V20.8H120.92Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.92 20.8V11.2H122.421L127.086 18.6672H127.141L127.086 16.8176V11.2H128.322V20.8H127.034L122.154 12.9696H122.099L122.154 14.8208V20.8H120.92Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.099 48H174.083V27.9984H171.099V48ZM197.989 35.2032L194.566 43.8752H194.464L190.912 35.2032H187.698L193.024 47.3232L189.986 54.0656H193.099L201.309 35.2032H197.989ZM181.056 45.728C180.08 45.728 178.715 45.2384 178.715 44.0304C178.715 42.4864 180.414 41.8944 181.882 41.8944C183.192 41.8944 183.811 42.1776 184.608 42.5632C184.376 44.416 182.781 45.728 181.056 45.728ZM181.418 34.7664C179.256 34.7664 177.018 35.7184 176.091 37.8288L178.741 38.9344C179.307 37.8288 180.363 37.4672 181.469 37.4672C183.013 37.4672 184.582 38.3936 184.608 40.04V40.2464C184.067 39.9376 182.909 39.4752 181.494 39.4752C178.637 39.4752 175.73 41.0448 175.73 43.9776C175.73 46.6544 178.072 48.3792 180.698 48.3792C182.702 48.3792 183.811 47.4784 184.504 46.4224H184.608V47.9664H187.491V40.2992C187.491 36.7472 184.838 34.7664 181.418 34.7664ZM162.966 37.6384H158.72V30.7824H162.966C165.198 30.7824 166.466 32.6304 166.466 34.2096C166.466 35.76 165.198 37.6384 162.966 37.6384ZM162.89 27.9984H155.736V48H158.72V40.4224H162.89C166.198 40.4224 169.451 38.0272 169.451 34.2096C169.451 30.3936 166.198 27.9984 162.89 27.9984ZM123.88 45.7328C121.818 45.7328 120.091 44.0048 120.091 41.6336C120.091 39.2352 121.818 37.4832 123.88 37.4832C125.915 37.4832 127.514 39.2352 127.514 41.6336C127.514 44.0048 125.915 45.7328 123.88 45.7328ZM127.307 36.3232H127.205C126.534 35.5248 125.245 34.8016 123.622 34.8016C120.219 34.8016 117.101 37.7936 117.101 41.6336C117.101 45.448 120.219 48.4128 123.622 48.4128C125.245 48.4128 126.534 47.6912 127.205 46.8672H127.307V47.8448C127.307 50.4496 125.915 51.84 123.674 51.84C121.843 51.84 120.709 50.5264 120.245 49.4176L117.642 50.5008C118.389 52.304 120.373 54.5216 123.674 54.5216C127.179 54.5216 130.144 52.4592 130.144 47.4336V35.2144H127.307V36.3232ZM132.206 48H135.195V27.9984H132.206V48ZM139.603 41.4016C139.526 38.7712 141.64 37.432 143.162 37.432C144.347 37.432 145.352 38.0256 145.688 38.8752L139.603 41.4016ZM148.883 39.1328C148.315 37.6128 146.589 34.8016 143.058 34.8016C139.552 34.8016 136.638 37.5616 136.638 41.608C136.638 45.4224 139.526 48.4128 143.392 48.4128C146.51 48.4128 148.315 46.5056 149.064 45.3968L146.744 43.8496C145.97 44.984 144.914 45.7328 143.392 45.7328C141.872 45.7328 140.789 45.0352 140.094 43.6688L149.192 39.9056L148.883 39.1328ZM76.3904 36.8912V39.7776H83.2992C83.0928 41.4016 82.5504 42.5872 81.7264 43.4112C80.72 44.4176 79.1472 45.5264 76.3904 45.5264C72.136 45.5264 68.8112 42.0976 68.8112 37.8448C68.8112 33.592 72.136 30.1632 76.3904 30.1632C78.6848 30.1632 80.36 31.0656 81.5968 32.2256L83.6336 30.1888C81.9056 28.5392 79.6128 27.2752 76.3904 27.2752C70.5648 27.2752 65.6672 32.0192 65.6672 37.8448C65.6672 43.6688 70.5648 48.4128 76.3904 48.4128C79.5344 48.4128 81.9056 47.3808 83.7616 45.448C85.6688 43.5408 86.2624 40.8608 86.2624 38.6944C86.2624 38.0256 86.2112 37.4064 86.1072 36.8912H76.3904ZM94.1152 45.7328C92.0544 45.7328 90.2752 44.0304 90.2752 41.608C90.2752 39.1584 92.0544 37.4832 94.1152 37.4832C96.1776 37.4832 97.9568 39.1584 97.9568 41.608C97.9568 44.0304 96.1776 45.7328 94.1152 45.7328ZM94.1152 34.8016C90.352 34.8016 87.2848 37.664 87.2848 41.608C87.2848 45.5264 90.352 48.4128 94.1152 48.4128C97.88 48.4128 100.947 45.5264 100.947 41.608C100.947 37.664 97.88 34.8016 94.1152 34.8016ZM109.018 45.7328C106.955 45.7328 105.176 44.0304 105.176 41.608C105.176 39.1584 106.955 37.4832 109.018 37.4832C111.08 37.4832 112.858 39.1584 112.858 41.608C112.858 44.0304 111.08 45.7328 109.018 45.7328ZM109.018 34.8016C105.254 34.8016 102.187 37.664 102.187 41.608C102.187 45.5264 105.254 48.4128 109.018 48.4128C112.781 48.4128 115.848 45.5264 115.848 41.608C115.848 37.664 112.781 34.8016 109.018 34.8016Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.696 12.0608C16.232 12.5536 15.9568 13.3184 15.9568 14.3088V49.6944C15.9568 50.6864 16.232 51.4512 16.696 51.9424L16.8144 52.0576L36.6384 32.2352V32.0016V31.768L16.8144 11.944L16.696 12.0608Z",
    fill: "url(#paint0_linear_google_button)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6384 31.768V32.0016V32.2352L43.2448 38.8448L43.3952 38.7616L51.224 34.3136C53.4592 33.0416 53.4592 30.9616 51.224 29.6928L43.3952 25.2432L43.2464 25.1584L36.6384 31.768Z",
    fill: "url(#paint1_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.696 51.9424C17.4336 52.7216 18.6512 52.8192 20.0224 52.0416L43.3952 38.76L36.6384 32.0016L16.696 51.9424Z",
    fill: "url(#paint2_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6384 32.0016L43.3952 25.2432L20.0224 11.9632C19.3792 11.5968 18.7696 11.424 18.2288 11.424C17.6144 11.424 17.088 11.6464 16.696 12.0608L36.6384 32.0016Z",
    fill: "url(#paint3_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0219 12.1968L51.2235 29.9248C52.2379 30.5008 52.8059 31.2432 52.9003 32.0016C52.9019 31.1648 52.3419 30.3264 51.2235 29.6912L20.0219 11.9632C17.7851 10.6928 15.9563 11.7488 15.9563 14.3088V14.5424C15.9563 11.9824 17.7851 10.9264 20.0219 12.1968Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_google_button",
    x1: 26.2976,
    y1: 11.944,
    x2: 16.4298,
    y2: 50.2224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31424,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49731,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75327,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 52.9004,
    y1: 32.0016,
    x2: 36.6384,
    y2: 32.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39205,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72986,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 39.723,
    y1: 38.3601,
    x2: 10.7027,
    y2: 67.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.0446,
    y1: 15.6013,
    x2: 32.5493,
    y2: 32.0226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13337,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49718,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82485,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetItOnPlayStore);
export default __webpack_public_path__ + "static/media/getItOnPlayStore.0a42bec7eccb1652b1ac3ff86f20979c.svg";
export { ForwardRef as ReactComponent };